import { makeStyles, Typography } from '@material-ui/core';
import React, { useContext } from 'react';
import { SubmitHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { generatePath, useHistory } from 'react-router-dom';
import ArrowBackIcon from '@material-ui/icons/ArrowBackOutlined';
import { Step1, Step2 } from 'components/Forms/ClientCreateForm';
import MultiStepForm from 'components/Forms/MultiStepForm';
import { notify } from 'components/Notifier';
import { AppContext } from 'context';
import { Routes } from 'routes';
import { postClient } from 'services/apiOperations';
import { Client, ClientCreateForm, Stream } from 'types';
import { formatClientBeforePost } from 'utils/normalizer';

const useStyles = makeStyles({
  headerTitle: {
    marginBottom: '2rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignContent: 'center',
  },
  title: {
    margin: 0,
  },
});

export type ClientFormContext = {
  client?: Client;
  stream?: Stream;
};

const ClientCreate: React.FC = () => {
  const context = useContext(AppContext);
  const history = useHistory();
  const classes = useStyles();
  const { t } = useTranslation('translation', { keyPrefix: 'clients' });

  const onSubmit: SubmitHandler<ClientCreateForm> = async (clientCreateForm: ClientCreateForm) => {
    const sortingCenter = context.getSortingCenter?.() ?? null;

    if (null === sortingCenter) {
      notify({
        message: t('errorGeneric'),
        severity: 'error',
      });
      return;
    }

    const formattedClient = formatClientBeforePost(clientCreateForm, sortingCenter);

    return postClient(formattedClient)
      .then((newClient: Client) => {
        notify({
          message: t('create.successMessage'),
          severity: 'success',
        });

        history.push(generatePath(Routes.ClientShow, { clientId: newClient.id }));
      })
      .catch(() => {
        notify({
          message: t('errorGeneric'),
          severity: 'error',
        });
      });
  };

  const steps = [
    { label: t('create.step1.title'), component: Step1, requiredFieldsLegend: true },
    { label: t('create.step2.title'), component: Step2 },
  ];

  const initialData = {};

  return (
    <>
      <div className={classes.headerTitle}>
        <Typography variant="h1" className={classes.title}>
          {t('create.title')}
        </Typography>
      </div>
      <MultiStepForm
        formName="clientCreateForm"
        backRoute="/referentiels/clients"
        backIcon={<ArrowBackIcon />}
        onSubmit={onSubmit}
        steps={steps}
        initialData={initialData}
      />
    </>
  );
};
export default ClientCreate;
